<template>
  <div>
    <svg
      :height="height"
      :width="width"
      viewBox="0 0 1500 3000"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="isMounted"
    >
      <path
        d="M436.5 1194.5L383.5 1299L373 1315L303 1262.5L337 1173.5C346 1156.5 367.5 1115 381.5 1085C389.5 1043.5 413 931.5 419 919C425 906.5 448.5 877.5 463 865C461.4 855 467.667 809.5 471 788L495.5 674.5L484.5 622.5C488.833 601.833 498.5 556.3 502.5 539.5C506.5 522.7 523.5 502.5 531.5 494.5L559 480L597.5 458C611.833 446.667 647.6 421.2 676 410C704.4 398.8 729.5 383 738.5 376.5L736 317.5V264H886.5C885.333 269 882.6 285.9 881 313.5C879.4 341.1 881.667 368.667 883 379C896.167 385.833 926.6 401.6 943 410C963.5 420.5 1002 445.5 1020 457.5C1038 469.5 1049 473.5 1087.5 494C1116.3 515.2 1127.17 571.833 1129 597.5C1131 605 1134.9 621.7 1134.5 628.5C1134.1 635.3 1126 660.333 1122 672C1128.17 701 1141.9 765.2 1147.5 790C1153.1 814.8 1155.17 850.333 1155.5 865C1162.5 871.833 1179.7 889.4 1192.5 905C1205.3 920.6 1215.5 968.5 1219 990.5L1238.5 1089L1283 1173.5L1309.5 1217.5L1230.5 1299L1177.5 1194.5C1145.67 1138 1080.6 1020.9 1075 1004.5C1068 984 1053 947.5 1053 882C1048.5 857.5 1031 805.5 1020 785C1016.5 803.5 994.5 854.5 989.5 865C994 887.5 999.5 939.5 1002 1000.5C1011 1025.5 1020 1051 1024 1108C1024 1160 1027.5 1185 1033.5 1242C1033.5 1299 1033.5 1322 1029.5 1366C1026.3 1401.2 1018.17 1492.67 1014.5 1534C1010.33 1562.67 999 1626 987 1650C995 1673 1003.5 1693 993 1732C1003.5 1754 1008 1758 1009.5 1777.5C1010.7 1793.1 1005 1902.67 1002 1955.5H895L878.5 1905C871.333 1888.83 857.7 1851.1 860.5 1829.5C863.3 1807.9 866.667 1769.83 868 1753.5C864.167 1739.83 856.4 1705 856 1675C851 1654.5 836 1574 832.5 1497.5C825.7 1458.3 812.667 1412.17 807 1394C801.333 1412.17 788.3 1458.3 781.5 1497.5C778 1574 763 1654.5 758 1675C757.6 1705 749.833 1739.83 746 1753.5C747.333 1769.83 750.7 1807.9 753.5 1829.5C756.3 1851.1 742.667 1888.83 735.5 1905L719 1955.5H612C609 1902.67 603.3 1793.1 604.5 1777.5C606 1758 610.5 1754 621 1732C610.5 1693 619 1673 627 1650C615 1626 603.667 1562.67 599.5 1534C595.833 1492.67 587.7 1401.2 584.5 1366C580.5 1322 580.5 1299 580.5 1242C586.5 1185 590 1160 590 1108C594 1051 603 1025.5 612 1000.5C614.5 939.5 620 887.5 624.5 865C619.5 854.5 597.5 803.5 594 785C583 805.5 565.5 857.5 561 882C561 947.5 546 984 539 1004.5C533.4 1020.9 468.333 1138 436.5 1194.5Z"
        fill="#C4C4C4"
        stroke="#FF0606"
        stroke-width="8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M291.93 1164.85C291.93 1164.85 291.079 1202.06 305.188 1222.74C319.298 1243.43 375.227 1299.01 401.641 1310.78C420.992 1339.5 470.362 1400.03 470.362 1400.03C470.362 1400.03 489.278 1437.26 493.27 1455.51C497.262 1473.76 521 1498.92 521 1498.92C521 1498.92 511.705 1522.88 489.653 1523.04C467.601 1523.2 443.811 1493.64 428.165 1472.38C412.519 1451.12 367.882 1407.26 367.882 1407.26C367.882 1407.26 346.81 1414.12 348.597 1424.15C350.384 1434.18 347.814 1505.69 349.802 1527.86C351.791 1550.04 364.038 1608.73 364.266 1635.21C364.494 1661.69 362.692 1738.72 355.829 1754.6C344.728 1769.08 319.085 1773.88 310.014 1750.99C300.943 1728.1 289.524 1636.41 289.524 1636.41L272.65 1541.13C272.65 1541.13 259.435 1503.11 253.366 1523.04C247.296 1542.98 249.75 1614.7 249.75 1614.7L250.955 1670.18L247.339 1729.28C247.339 1729.28 245.459 1777.34 236.491 1794.4C227.524 1811.47 191.623 1827.62 183.443 1791.99C175.262 1756.36 182.735 1685.99 184.648 1665.35C186.561 1644.72 184.147 1584.28 184.648 1566.46C185.149 1548.63 190.675 1514.6 190.675 1514.6C190.675 1514.6 180.563 1510.58 178.622 1521.84C176.68 1533.09 172.595 1648.48 172.595 1648.48L158.132 1725.66C158.132 1725.66 151.846 1762.84 138.847 1766.67C125.848 1770.5 96.218 1775.89 107.5 1703.94C113.131 1632.01 115.922 1568.3 115.937 1547.16C115.951 1526.02 118.347 1489.27 118.347 1489.27C118.347 1489.27 107.755 1477.3 102.678 1495.31C97.6017 1513.32 84.599 1561.64 84.599 1561.64L73.7513 1614.7C73.7513 1614.7 62.5758 1659.31 53.2613 1668.98C43.9468 1678.65 24.726 1683.15 19.5034 1665.35C14.2809 1647.55 23.8292 1606.99 30.3511 1578.52C36.8729 1550.05 52.6924 1471.49 53.2589 1442.24C53.8254 1412.99 67.6766 1318.77 71.3383 1290.27C73.5922 1261.78 88.8151 1229.23 100.274 1209.47C93.3663 1162.86 93.0421 1153.99 93.0421 1153.99"
        fill="#C4C4C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1287.07 1164.86C1287.07 1164.86 1287.92 1202.07 1273.81 1222.75C1259.7 1243.43 1203.77 1299.02 1177.36 1310.78C1158.01 1339.51 1108.64 1400.04 1108.64 1400.04C1108.64 1400.04 1089.72 1437.27 1085.73 1455.52C1081.74 1473.77 1058 1498.93 1058 1498.93C1058 1498.93 1067.3 1522.89 1089.35 1523.05C1111.4 1523.21 1135.19 1493.65 1150.84 1472.39C1166.48 1451.13 1211.12 1407.27 1211.12 1407.27C1211.12 1407.27 1232.19 1414.13 1230.4 1424.16C1228.62 1434.18 1231.19 1505.69 1229.2 1527.87C1227.21 1550.05 1214.96 1608.73 1214.73 1635.21C1214.51 1661.69 1216.31 1738.73 1223.17 1754.61C1234.27 1769.09 1259.91 1773.88 1268.99 1751C1278.06 1728.11 1289.48 1636.42 1289.48 1636.42L1306.35 1541.14C1306.35 1541.14 1319.56 1503.11 1325.63 1523.05C1331.7 1542.99 1329.25 1614.71 1329.25 1614.71L1328.05 1670.19L1331.66 1729.29C1331.66 1729.29 1333.54 1777.34 1342.51 1794.41C1351.48 1811.48 1387.38 1827.63 1395.56 1792C1403.74 1756.37 1396.26 1685.99 1394.35 1665.36C1392.44 1644.72 1394.85 1584.29 1394.35 1566.46C1393.85 1548.64 1388.33 1514.61 1388.33 1514.61C1388.33 1514.61 1398.44 1510.59 1400.38 1521.84C1402.32 1533.1 1406.4 1648.48 1406.4 1648.48L1420.87 1725.67C1420.87 1725.67 1427.15 1762.84 1440.15 1766.68C1453.15 1770.51 1482.78 1775.9 1471.5 1703.95C1465.87 1632.02 1463.08 1568.31 1463.06 1547.17C1463.05 1526.03 1460.65 1489.28 1460.65 1489.28C1460.65 1489.28 1471.24 1477.31 1476.32 1495.32C1481.4 1513.32 1494.4 1561.64 1494.4 1561.64L1505.25 1614.71C1505.25 1614.71 1516.42 1659.32 1525.74 1668.99C1535.05 1678.65 1554.27 1683.16 1559.5 1665.36C1564.72 1647.56 1555.17 1607 1548.65 1578.53C1542.13 1550.06 1526.31 1471.5 1525.74 1442.25C1525.17 1412.99 1511.32 1318.78 1507.66 1290.28C1505.41 1261.79 1490.18 1229.23 1478.73 1209.48C1485.63 1162.87 1485.96 1154 1485.96 1154"
        fill="#C4C4C4"
      />
      <path
        d="M291.93 1164.85C291.93 1164.85 291.079 1202.06 305.188 1222.74C319.298 1243.43 375.227 1299.01 401.641 1310.78C420.992 1339.5 470.362 1400.03 470.362 1400.03C470.362 1400.03 489.278 1437.26 493.27 1455.51C497.262 1473.76 521 1498.92 521 1498.92C521 1498.92 511.705 1522.88 489.653 1523.04C467.601 1523.2 443.811 1493.64 428.165 1472.38C412.519 1451.12 367.882 1407.26 367.882 1407.26C367.882 1407.26 346.81 1414.12 348.597 1424.15C350.384 1434.18 347.814 1505.69 349.802 1527.86C351.791 1550.04 364.038 1608.73 364.266 1635.21C364.494 1661.69 362.692 1738.72 355.829 1754.6C344.728 1769.08 319.085 1773.88 310.014 1750.99C300.943 1728.1 289.524 1636.41 289.524 1636.41L272.65 1541.13C272.65 1541.13 259.435 1503.11 253.366 1523.04C247.296 1542.98 249.75 1614.7 249.75 1614.7L250.955 1670.18L247.339 1729.28C247.339 1729.28 245.459 1777.34 236.491 1794.4C227.524 1811.47 191.623 1827.62 183.443 1791.99C175.262 1756.36 182.735 1685.99 184.648 1665.35C186.561 1644.72 184.147 1584.28 184.648 1566.46C185.149 1548.63 190.675 1514.6 190.675 1514.6C190.675 1514.6 180.563 1510.58 178.622 1521.84C176.68 1533.09 172.595 1648.48 172.595 1648.48L158.132 1725.66C158.132 1725.66 151.846 1762.84 138.847 1766.67C125.848 1770.5 96.218 1775.89 107.5 1703.94C113.131 1632.01 115.922 1568.3 115.937 1547.16C115.951 1526.02 118.347 1489.27 118.347 1489.27C118.347 1489.27 107.755 1477.3 102.678 1495.31C97.6017 1513.32 84.599 1561.64 84.599 1561.64L73.7513 1614.7C73.7513 1614.7 62.5758 1659.31 53.2613 1668.98C43.9468 1678.65 24.726 1683.15 19.5034 1665.35C14.2809 1647.55 23.8292 1606.99 30.3511 1578.52C36.8729 1550.05 52.6924 1471.49 53.2589 1442.24C53.8254 1412.99 67.6766 1318.77 71.3383 1290.27C73.5922 1261.78 88.8151 1229.23 100.274 1209.47C93.3663 1162.86 93.0421 1153.99 93.0421 1153.99M1287.07 1164.86C1287.07 1164.86 1287.92 1202.07 1273.81 1222.75C1259.7 1243.43 1203.77 1299.02 1177.36 1310.78C1158.01 1339.51 1108.64 1400.04 1108.64 1400.04C1108.64 1400.04 1089.72 1437.27 1085.73 1455.52C1081.74 1473.77 1058 1498.93 1058 1498.93C1058 1498.93 1067.3 1522.89 1089.35 1523.05C1111.4 1523.21 1135.19 1493.65 1150.84 1472.39C1166.48 1451.13 1211.12 1407.27 1211.12 1407.27C1211.12 1407.27 1232.19 1414.13 1230.4 1424.16C1228.62 1434.18 1231.19 1505.69 1229.2 1527.87C1227.21 1550.05 1214.96 1608.73 1214.73 1635.21C1214.51 1661.69 1216.31 1738.73 1223.17 1754.61C1234.27 1769.09 1259.91 1773.88 1268.99 1751C1278.06 1728.11 1289.48 1636.42 1289.48 1636.42L1306.35 1541.14C1306.35 1541.14 1319.56 1503.11 1325.63 1523.05C1331.7 1542.99 1329.25 1614.71 1329.25 1614.71L1328.05 1670.19L1331.66 1729.29C1331.66 1729.29 1333.54 1777.34 1342.51 1794.41C1351.48 1811.48 1387.38 1827.63 1395.56 1792C1403.74 1756.37 1396.26 1685.99 1394.35 1665.36C1392.44 1644.72 1394.85 1584.29 1394.35 1566.46C1393.85 1548.64 1388.33 1514.61 1388.33 1514.61C1388.33 1514.61 1398.44 1510.59 1400.38 1521.84C1402.32 1533.1 1406.4 1648.48 1406.4 1648.48L1420.87 1725.67C1420.87 1725.67 1427.15 1762.84 1440.15 1766.68C1453.15 1770.51 1482.78 1775.9 1471.5 1703.95C1465.87 1632.02 1463.08 1568.31 1463.06 1547.17C1463.05 1526.03 1460.65 1489.28 1460.65 1489.28C1460.65 1489.28 1471.24 1477.31 1476.32 1495.32C1481.4 1513.32 1494.4 1561.64 1494.4 1561.64L1505.25 1614.71C1505.25 1614.71 1516.42 1659.32 1525.74 1668.99C1535.05 1678.65 1554.27 1683.16 1559.5 1665.36C1564.72 1647.56 1555.17 1607 1548.65 1578.53C1542.13 1550.06 1526.31 1471.5 1525.74 1442.25C1525.17 1412.99 1511.32 1318.78 1507.66 1290.28C1505.41 1261.79 1490.18 1229.23 1478.73 1209.48C1485.63 1162.87 1485.96 1154 1485.96 1154"
        stroke="#EE3B11"
        stroke-width="12"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M906.769 1860.32C906.769 1860.32 883.482 1975.49 889.269 2010.7C895.055 2045.91 909.51 2050.82 903.269 2070.15C897.027 2089.49 888.499 2273.55 892.769 2323.11C893.06 2382.57 870.03 2474.33 857.757 2529.45C849.462 2586.54 851.48 2605.18 855.423 2628.54C859.367 2651.9 869.424 2694.98 869.424 2694.98C873.87 2714.47 875.053 2734.56 872.924 2754.44C869.284 2786.56 891.45 2823.29 909.102 2826.71C926.754 2830.13 969.092 2842.62 982.614 2818.55C996.136 2794.48 1007.01 2769.59 996.614 2740.44C986.219 2711.3 971.076 2680.61 982.614 2675.16C994.153 2669.72 992.753 2675.39 994.281 2684.48C995.809 2693.58 1005.95 2745.11 1005.95 2745.11C1005.95 2745.11 1007.86 2769.48 1021.13 2769.59C1034.39 2769.69 1059.74 2772.18 1067.79 2757.92C1075.84 2743.67 1075.98 2718.47 1070.13 2703.14C1064.27 2687.82 1057.29 2662.34 1057.29 2662.34C1057.29 2662.34 1060.46 2656.29 1064.29 2660C1068.13 2663.71 1076.89 2690.13 1078.29 2701.98C1079.69 2713.83 1078.51 2730.46 1082.96 2740.44C1087.41 2750.43 1131.05 2748.1 1134.3 2735.78C1137.55 2723.45 1138.21 2697.55 1135.47 2684.48C1132.73 2671.42 1126.11 2649.52 1131.97 2649.52C1137.83 2649.52 1142.47 2672.83 1142.47 2672.83L1145.97 2712.46C1145.97 2712.46 1152.34 2728.74 1162.3 2729.96C1172.26 2731.17 1203.72 2721.06 1201.98 2707.81C1200.23 2694.56 1189.14 2647.19 1189.14 2647.19V2622.71C1189.14 2622.71 1195.35 2616.21 1197.31 2625.04C1199.26 2633.87 1200.81 2664.67 1200.81 2664.67C1200.81 2664.67 1204.08 2701.23 1211.31 2708.96C1218.54 2716.7 1242.76 2728.95 1253.32 2719.46C1263.87 2709.97 1272.54 2694.01 1269.65 2657.68C1266.76 2621.35 1271.42 2568.92 1271.98 2538.77C1272.54 2508.62 1259 2467.27 1255.65 2451.34C1252.3 2435.41 1263.32 2321.13 1248.65 2271.82C1233.98 2222.51 1205.15 2159.55 1194.97 2114.45C1184.8 2069.35 1182.06 2014.5 1179.81 2010.7C1177.55 2006.9 1184.05 1981.89 1171.64 1950.09C1159.23 1918.28 1147.98 1866.05 1148.31 1844C1097.52 1851.8 978.122 1870.92 906.769 1860.32Z"
        fill="#C4C4C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M716.655 1860.32C716.655 1860.32 739.941 1975.49 734.155 2010.7C728.368 2045.91 713.913 2050.82 720.155 2070.15C726.396 2089.49 734.925 2273.55 730.655 2323.11C730.363 2382.57 753.393 2474.33 765.667 2529.45C773.962 2586.54 771.943 2605.18 768 2628.54C764.057 2651.9 754 2694.98 754 2694.98C749.553 2714.47 748.37 2734.56 750.5 2754.44C754.14 2786.56 731.973 2823.29 714.321 2826.71C696.67 2830.13 654.331 2842.62 640.809 2818.55C627.288 2794.48 616.414 2769.59 626.809 2740.44C637.204 2711.3 652.348 2680.61 640.809 2675.16C629.271 2669.72 630.671 2675.39 629.143 2684.48C627.614 2693.58 617.476 2745.11 617.476 2745.11C617.476 2745.11 615.562 2769.48 602.297 2769.59C589.032 2769.69 563.68 2772.18 555.63 2757.92C547.58 2743.67 547.44 2718.47 553.297 2703.14C559.154 2687.82 566.13 2662.34 566.13 2662.34C566.13 2662.34 562.965 2656.29 559.13 2660C555.296 2663.71 546.53 2690.13 545.13 2701.98C543.73 2713.83 544.915 2730.46 540.464 2740.44C536.013 2750.43 492.373 2748.1 489.122 2735.78C485.87 2723.45 485.218 2697.55 487.955 2684.48C490.692 2671.42 497.314 2649.52 491.455 2649.52C485.596 2649.52 480.955 2672.83 480.955 2672.83L477.455 2712.46C477.455 2712.46 471.08 2728.74 461.122 2729.96C451.163 2731.17 419.705 2721.06 421.448 2707.81C423.191 2694.56 434.281 2647.19 434.281 2647.19V2622.71C434.281 2622.71 428.069 2616.21 426.115 2625.04C424.16 2633.87 422.615 2664.67 422.615 2664.67C422.615 2664.67 419.348 2701.23 412.114 2708.96C404.881 2716.7 380.661 2728.95 370.107 2719.46C359.553 2709.97 350.882 2694.01 353.774 2657.68C356.666 2621.35 352.002 2568.92 351.44 2538.77C350.879 2508.62 364.426 2467.27 367.774 2451.34C371.122 2435.41 360.103 2321.13 374.774 2271.82C389.445 2222.51 418.274 2159.55 428.45 2114.45C438.626 2069.35 441.361 2014.5 443.617 2010.7C445.873 2006.9 439.373 1981.89 451.784 1950.09C464.195 1918.28 475.439 1866.05 475.117 1844C525.902 1851.8 645.301 1870.92 716.655 1860.32Z"
        fill="#C4C4C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M906.769 1860.32C906.769 1860.32 883.482 1975.49 889.269 2010.7C895.055 2045.91 909.51 2050.82 903.269 2070.15C897.027 2089.49 888.499 2273.55 892.769 2323.11C893.06 2382.57 870.03 2474.33 857.757 2529.45C849.462 2586.54 851.48 2605.18 855.423 2628.54C859.367 2651.9 869.424 2694.98 869.424 2694.98C873.87 2714.47 875.053 2734.56 872.924 2754.44C869.284 2786.56 891.45 2823.29 909.102 2826.71C926.754 2830.13 969.092 2842.62 982.614 2818.55C996.136 2794.48 1007.01 2769.59 996.614 2740.44C986.219 2711.3 971.076 2680.61 982.614 2675.16C994.153 2669.72 992.753 2675.39 994.281 2684.48C995.809 2693.58 1005.95 2745.11 1005.95 2745.11C1005.95 2745.11 1007.86 2769.48 1021.13 2769.59C1034.39 2769.69 1059.74 2772.18 1067.79 2757.92C1075.84 2743.67 1075.98 2718.47 1070.13 2703.14C1064.27 2687.82 1057.29 2662.34 1057.29 2662.34C1057.29 2662.34 1060.46 2656.29 1064.29 2660C1068.13 2663.71 1076.89 2690.13 1078.29 2701.98C1079.69 2713.83 1078.51 2730.46 1082.96 2740.44C1087.41 2750.43 1131.05 2748.1 1134.3 2735.78C1137.55 2723.45 1138.21 2697.55 1135.47 2684.48C1132.73 2671.42 1126.11 2649.52 1131.97 2649.52C1137.83 2649.52 1142.47 2672.83 1142.47 2672.83L1145.97 2712.46C1145.97 2712.46 1152.34 2728.74 1162.3 2729.96C1172.26 2731.17 1203.72 2721.06 1201.98 2707.81C1200.23 2694.56 1189.14 2647.19 1189.14 2647.19V2622.71C1189.14 2622.71 1195.35 2616.21 1197.31 2625.04C1199.26 2633.87 1200.81 2664.67 1200.81 2664.67C1200.81 2664.67 1204.08 2701.23 1211.31 2708.96C1218.54 2716.7 1242.76 2728.95 1253.32 2719.46C1263.87 2709.97 1272.54 2694.01 1269.65 2657.68C1266.76 2621.35 1271.42 2568.92 1271.98 2538.77C1272.54 2508.62 1259 2467.27 1255.65 2451.34C1252.3 2435.41 1263.32 2321.13 1248.65 2271.82C1233.98 2222.51 1205.15 2159.55 1194.97 2114.45C1184.8 2069.35 1182.06 2014.5 1179.81 2010.7C1177.55 2006.9 1184.05 1981.89 1171.64 1950.09C1159.23 1918.28 1147.98 1866.05 1148.31 1844C1097.52 1851.8 978.122 1870.92 906.769 1860.32Z"
        stroke="#EE3B11"
        stroke-width="12"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M716.655 1860.32C716.655 1860.32 739.941 1975.49 734.155 2010.7C728.368 2045.91 713.913 2050.82 720.155 2070.15C726.396 2089.49 734.925 2273.55 730.655 2323.11C730.363 2382.57 753.393 2474.33 765.667 2529.45C773.962 2586.54 771.943 2605.18 768 2628.54C764.057 2651.9 754 2694.98 754 2694.98C749.553 2714.47 748.37 2734.56 750.5 2754.44C754.14 2786.56 731.973 2823.29 714.321 2826.71C696.67 2830.13 654.331 2842.62 640.809 2818.55C627.288 2794.48 616.414 2769.59 626.809 2740.44C637.204 2711.3 652.348 2680.61 640.809 2675.16C629.271 2669.72 630.671 2675.39 629.143 2684.48C627.614 2693.58 617.476 2745.11 617.476 2745.11C617.476 2745.11 615.562 2769.48 602.297 2769.59C589.032 2769.69 563.68 2772.18 555.63 2757.92C547.58 2743.67 547.44 2718.47 553.297 2703.14C559.154 2687.82 566.13 2662.34 566.13 2662.34C566.13 2662.34 562.965 2656.29 559.13 2660C555.296 2663.71 546.53 2690.13 545.13 2701.98C543.73 2713.83 544.915 2730.46 540.464 2740.44C536.013 2750.43 492.373 2748.1 489.122 2735.78C485.87 2723.45 485.218 2697.55 487.955 2684.48C490.692 2671.42 497.314 2649.52 491.455 2649.52C485.596 2649.52 480.955 2672.83 480.955 2672.83L477.455 2712.46C477.455 2712.46 471.08 2728.74 461.122 2729.96C451.163 2731.17 419.705 2721.06 421.448 2707.81C423.191 2694.56 434.281 2647.19 434.281 2647.19V2622.71C434.281 2622.71 428.069 2616.21 426.115 2625.04C424.16 2633.87 422.615 2664.67 422.615 2664.67C422.615 2664.67 419.348 2701.23 412.114 2708.96C404.881 2716.7 380.661 2728.95 370.107 2719.46C359.553 2709.97 350.882 2694.01 353.774 2657.68C356.666 2621.35 352.002 2568.92 351.44 2538.77C350.879 2508.62 364.426 2467.27 367.774 2451.34C371.122 2435.41 360.103 2321.13 374.774 2271.82C389.445 2222.51 418.274 2159.55 428.45 2114.45C438.626 2069.35 441.361 2014.5 443.617 2010.7C445.873 2006.9 439.373 1981.89 451.784 1950.09C464.195 1918.28 475.439 1866.05 475.117 1844C525.902 1851.8 645.301 1870.92 716.655 1860.32Z"
        stroke="#EE3B11"
        stroke-width="12"
      />
      <path
        d="M726.093 28.8104C734.598 20.3102 763.705 5.61629 808.833 6.42908C853.961 5.61629 883.069 20.3102 891.574 28.8104C900.079 37.3106 921.341 67.6586 923.485 82.9969C927.973 115.054 924.191 146.049 918.761 167.801C956.904 144.43 944.405 202.687 931.766 221.988C926.229 230.437 905.756 240.835 905.756 240.835C905.756 240.835 902.646 284.973 895.119 296.199C887.592 307.425 875.07 318.371 864.374 328.004C853.731 337.59 823.832 347.085 803.83 346.856C783.928 347.083 763.934 337.589 753.292 328.004C742.596 318.371 730.074 307.425 722.547 296.199C715.02 284.973 711.91 240.835 711.91 240.835C711.91 240.835 691.437 230.437 685.901 221.987C673.261 202.686 660.763 144.43 698.906 167.801C693.475 146.049 689.694 115.054 694.182 82.9969C696.326 67.6586 717.588 37.3106 726.093 28.8104Z"
        fill="#C4C4C4"
      />
      <path
        d="M804.133 346.852C784.131 347.179 763.988 337.638 753.292 328.004C742.596 318.371 730.074 307.425 722.547 296.199C715.02 284.973 711.91 240.835 711.91 240.835C711.91 240.835 691.437 230.437 685.901 221.987C673.261 202.686 660.763 144.43 698.906 167.801C693.475 146.049 689.694 115.054 694.182 82.9969C696.326 67.6586 717.588 37.3107 726.093 28.8104C734.598 20.3102 763.705 5.61629 808.833 6.42908C853.961 5.61629 883.069 20.3102 891.574 28.8104C900.079 37.3106 921.341 67.6586 923.485 82.9969C927.973 115.054 924.191 146.049 918.761 167.801C956.904 144.43 944.405 202.687 931.766 221.988C926.229 230.437 905.756 240.835 905.756 240.835C905.756 240.835 902.646 284.973 895.119 296.199C887.592 307.425 875.07 318.371 864.374 328.004C853.678 337.638 823.535 347.179 803.533 346.852"
        stroke="#EE3B11"
        stroke-width="8"
      />
      <path
        d="M834 151C840.333 146.5 859.5 140.9 885.5 154.5M776.5 151C770.167 146.5 751 140.9 725 154.5"
        stroke="#EE3B11"
        stroke-width="5"
        stroke-linecap="square"
      />
      <path
        d="M843 161L831.5 174.5C835.333 175.667 845.3 177.9 854.5 177.5C866 177 866 174.5 874 168C864.8 162.8 849.5 161.167 843 161Z"
        fill="#878787"
      />
      <path
        d="M766.5 161L778 174.5C774.167 175.667 764.2 177.9 755 177.5C743.5 177 743.5 174.5 735.5 168C744.7 162.8 760 161.167 766.5 161Z"
        fill="#878787"
      />
      <path
        d="M843 161L831.5 174.5C835.333 175.667 845.3 177.9 854.5 177.5C866 177 866 174.5 874 168C864.8 162.8 849.5 161.167 843 161Z"
        stroke="#EE3B11"
        stroke-width="3"
        stroke-linecap="square"
      />
      <path
        d="M766.5 161L778 174.5C774.167 175.667 764.2 177.9 755 177.5C743.5 177 743.5 174.5 735.5 168C744.7 162.8 760 161.167 766.5 161Z"
        stroke="#EE3B11"
        stroke-width="3"
        stroke-linecap="square"
      />
      <path
        d="M795 237.5C790.5 236.5 786.667 234.667 785 233.5C785 239.5 791.5 249 796 249.5C801.5 250.5 805 250.5 811 249C815.909 247.773 818.5 239.5 819.5 233.5L815.5 236L811 237.5C806 238.5 798.924 238.372 795 237.5Z"
        fill="#979797"
        stroke="#EE3B11"
        stroke-width="3"
        stroke-linecap="square"
      />
      <path
        d="M815 293.5L830.5 283.5L773 284.5L787 293.5H815Z"
        fill="#9B9797"
        stroke="#EE3B11"
        stroke-width="3"
        stroke-linecap="square"
      />
      <path
        d="M790.5 274L767 284H790.5L803 288L814 284H836L814 274L803 278.5L790.5 274Z"
        fill="#A7A7A7"
        stroke="#EE3B11"
        stroke-width="3"
        stroke-linecap="square"
      />
      <path
        d="M745 2721C744.6 2713 750.833 2686 754 2673.5C709.5 2618.5 648 2675 648.5 2679.5C649 2684 645.5 2702.5 641.5 2713C637.5 2723.5 630.5 2742 627 2760C624.5 2782.5 644 2817 647 2820.5C650 2824 655.5 2826.5 665 2828.5C679 2830 711.5 2823.5 718.5 2820.5C726.5 2815 728 2812 735.5 2801C745.9 2781.4 747.5 2765.5 747 2760C745 2742.5 745 2731 745 2721Z"
        fill="#FCF200"
      />
      <path
        d="M567 2669L581 2624C602.6 2588 655.5 2613 638.5 2643C634.667 2653.83 626.7 2676.5 625.5 2680.5C624 2685.5 617 2732.5 614.5 2745C612 2757.5 597 2773 586.5 2773C576 2773 560.5 2763 556.5 2749.5C553.3 2738.7 553.5 2720 554 2712L567 2669Z"
        fill="#FCF200"
      />
      <path
        d="M494 2662.5C495.6 2654.9 504.667 2616 509 2597.5C517.784 2560 592 2580 566 2628.5L560 2649C554 2665.17 542 2698.7 542 2703.5C542 2709.5 541.5 2736.5 537 2749.5C518.5 2762.5 499.5 2743 494 2736.5C488.5 2730 488.5 2701.5 489 2697.5C489.5 2693.5 492 2672 494 2662.5Z"
        fill="#FCF200"
      />
      <path
        d="M430 2672.5C435.6 2645.7 435 2609 434 2594C430.567 2542.5 510.5 2569.5 494 2603.5L485.5 2646.5C484 2652.83 480.4 2666.9 478 2672.5C475 2679.5 475.5 2702 475 2710.5C474.5 2719 472 2723.5 463 2729.5C454 2735.5 434 2738.5 427.5 2726.5C421 2714.5 423 2706 430 2672.5Z"
        fill="#FCF200"
      />
      <path
        d="M358 2669.5V2573C361.5 2532 434 2559 422 2600C421.667 2619.5 420.6 2660.7 419 2669.5C417 2680.5 420 2696 405.5 2709C391 2722 366 2711.5 361.5 2706C357.9 2701.6 357.667 2679.83 358 2669.5Z"
        fill="#FCF200"
      />
      <path
        d="M879 2721C879.4 2713 873.167 2686 870 2673.5C914.5 2618.5 976 2675 975.5 2679.5C975 2684 978.5 2702.5 982.5 2713C986.5 2723.5 993.5 2742 997 2760C999.5 2782.5 980 2817 977 2820.5C974 2824 968.5 2826.5 959 2828.5C945 2830 912.5 2823.5 905.5 2820.5C897.5 2815 896 2812 888.5 2801C878.1 2781.4 876.5 2765.5 877 2760C879 2742.5 879 2731 879 2721Z"
        fill="#FCF200"
      />
      <path
        d="M1057 2669L1043 2624C1021.4 2588 968.5 2613 985.5 2643C989.333 2653.83 997.3 2676.5 998.5 2680.5C1000 2685.5 1007 2732.5 1009.5 2745C1012 2757.5 1027 2773 1037.5 2773C1048 2773 1063.5 2763 1067.5 2749.5C1070.7 2738.7 1070.5 2720 1070 2712L1057 2669Z"
        fill="#FCF200"
      />
      <path
        d="M1130 2662.5C1128.4 2654.9 1119.33 2616 1115 2597.5C1106.22 2560 1032 2580 1058 2628.5L1064 2649C1070 2665.17 1082 2698.7 1082 2703.5C1082 2709.5 1082.5 2736.5 1087 2749.5C1105.5 2762.5 1124.5 2743 1130 2736.5C1135.5 2730 1135.5 2701.5 1135 2697.5C1134.5 2693.5 1132 2672 1130 2662.5Z"
        fill="#FCF200"
      />
      <path
        d="M1194 2672.5C1188.4 2645.7 1189 2609 1190 2594C1193.43 2542.5 1113.5 2569.5 1130 2603.5L1138.5 2646.5C1140 2652.83 1143.6 2666.9 1146 2672.5C1149 2679.5 1148.5 2702 1149 2710.5C1149.5 2719 1152 2723.5 1161 2729.5C1170 2735.5 1190 2738.5 1196.5 2726.5C1203 2714.5 1201 2706 1194 2672.5Z"
        fill="#FCF200"
      />
      <path
        d="M1266 2669.5V2573C1262.5 2532 1190 2559 1202 2600C1202.33 2619.5 1203.4 2660.7 1205 2669.5C1207 2680.5 1204 2696 1218.5 2709C1233 2722 1258 2711.5 1262.5 2706C1266.1 2701.6 1266.33 2679.83 1266 2669.5Z"
        fill="#FCF200"
      />
      <path
        d="M489.5 1462.5C492.7 1473.3 507.5 1492 514.5 1500C507.5 1511.5 503 1515 494 1517.5C482.5 1518.5 474.5 1513.5 466.5 1507.5C460.1 1502.7 439.833 1479.33 430.5 1468C422.667 1458.67 399.4 1432.2 369 1401C343.8 1364.6 377.833 1327.83 398 1314L466.5 1403.5C472.833 1418.67 486.3 1451.7 489.5 1462.5Z"
        fill="#FCF200"
      />
      <path
        d="M277 1538C273 1524.4 263.333 1514.67 259 1511.5C294.5 1451 339.5 1489.5 344 1495C342.5 1502 345.5 1541 349.5 1562C353.5 1583 356.5 1613.5 358.5 1629.5C360.5 1645.5 358.5 1655.5 358.5 1671.5C358.5 1687.5 353 1749.5 351.5 1752C350 1754.5 342 1762 334 1762C326 1762 319 1761 313.5 1746C308 1731 303.5 1694 303 1692C302.6 1690.4 296.5 1651.33 293.5 1632L289 1606C286.667 1589 281 1551.6 277 1538Z"
        fill="#FCF200"
      />
      <path
        d="M119.5 1590L123 1487C118 1433 200.5 1445.5 184 1487C180.667 1497.33 173.8 1519.3 173 1524.5C172.2 1529.7 170.333 1574.33 169.5 1596L167.5 1647.5C163.833 1665.83 155.7 1707.2 152.5 1726C148.5 1749.5 141 1759 139 1760.5C128.618 1764.95 125.08 1763.53 120.169 1761.57L120 1761.5C111.2 1755.1 110 1737.83 110.5 1730L115 1673L119.5 1590Z"
        fill="#FCF200"
      />
      <path
        d="M78.5 1569L105 1481.5C145 1422.5 57.5 1398 57.5 1442L54 1481.5L48.5 1514C43.5 1538.5 33.1 1589.1 31.5 1595.5C29.5 1603.5 21.5 1653.5 23.5 1662C25.5 1670.5 29 1672 34.5 1672.5C44.1 1672.1 50.5 1665.33 52.5 1662L67 1622L78.5 1569Z"
        fill="#FCF200"
      />
      <path
        d="M188.5 1574C188.5 1560 191.333 1516.83 193.5 1502C197 1442 277.909 1468.5 259 1507.5C256.333 1513 246.6 1532 245 1546C243 1563.5 244 1614.5 246 1626.5C247.979 1638.37 246.531 1662.98 246.016 1671.73L246 1672C245.5 1680.5 245 1686.5 244 1704.5C243 1722.5 236.5 1781 234 1788.5C231 1796 230 1800 216 1805.5C205.378 1809.67 194.5 1807.5 191.5 1800C188.5 1792.5 185 1776.5 184 1753.5C184.5 1731 186.5 1696 188 1683C189.2 1672.6 190.5 1646 191 1634C190.167 1619.83 188.5 1588 188.5 1574Z"
        fill="#FCF200"
      />
      <path
        d="M1090 1462.5C1086.8 1473.3 1072 1492 1065 1500C1072 1511.5 1076.5 1515 1085.5 1517.5C1097 1518.5 1105 1513.5 1113 1507.5C1119.4 1502.7 1139.67 1479.33 1149 1468C1156.83 1458.67 1180.1 1432.2 1210.5 1401C1235.7 1364.6 1201.67 1327.83 1181.5 1314L1113 1403.5C1106.67 1418.67 1093.2 1451.7 1090 1462.5Z"
        fill="#FCF200"
      />
      <path
        d="M1302.5 1538C1306.5 1524.4 1316.17 1514.67 1320.5 1511.5C1285 1451 1240 1489.5 1235.5 1495C1237 1502 1234 1541 1230 1562C1226 1583 1223 1613.5 1221 1629.5C1219 1645.5 1221 1655.5 1221 1671.5C1221 1687.5 1226.5 1749.5 1228 1752C1229.5 1754.5 1237.5 1762 1245.5 1762C1253.5 1762 1260.5 1761 1266 1746C1271.5 1731 1276 1694 1276.5 1692C1276.9 1690.4 1283 1651.33 1286 1632L1290.5 1606C1292.83 1589 1298.5 1551.6 1302.5 1538Z"
        fill="#FCF200"
      />
      <path
        d="M1460 1590L1456.5 1487C1461.5 1433 1379 1445.5 1395.5 1487C1398.83 1497.33 1405.7 1519.3 1406.5 1524.5C1407.3 1529.7 1409.17 1574.33 1410 1596L1412 1647.5C1415.67 1665.83 1423.8 1707.2 1427 1726C1431 1749.5 1438.5 1759 1440.5 1760.5C1450.88 1764.95 1454.42 1763.53 1459.33 1761.57L1459.5 1761.5C1468.3 1755.1 1469.5 1737.83 1469 1730L1464.5 1673L1460 1590Z"
        fill="#FCF200"
      />
      <path
        d="M1501 1569L1474.5 1481.5C1434.5 1422.5 1522 1398 1522 1442L1525.5 1481.5L1531 1514C1536 1538.5 1546.4 1589.1 1548 1595.5C1550 1603.5 1558 1653.5 1556 1662C1554 1670.5 1550.5 1672 1545 1672.5C1535.4 1672.1 1529 1665.33 1527 1662L1512.5 1622L1501 1569Z"
        fill="#FCF200"
      />
      <path
        d="M1391 1574C1391 1560 1388.17 1516.83 1386 1502C1382.5 1442 1301.59 1468.5 1320.5 1507.5C1323.17 1513 1332.9 1532 1334.5 1546C1336.5 1563.5 1335.5 1614.5 1333.5 1626.5C1331.52 1638.37 1332.97 1662.98 1333.48 1671.73L1333.5 1672C1334 1680.5 1334.5 1686.5 1335.5 1704.5C1336.5 1722.5 1343 1781 1345.5 1788.5C1348.5 1796 1349.5 1800 1363.5 1805.5C1374.12 1809.67 1385 1807.5 1388 1800C1391 1792.5 1394.5 1776.5 1395.5 1753.5C1395 1731 1393 1696 1391.5 1683C1390.3 1672.6 1389 1646 1388.5 1634C1389.33 1619.83 1391 1588 1391 1574Z"
        fill="#FCF200"
      />
      <path
        d="M961 730.5C993.4 706.1 1015.83 674.667 1023 662C1025.83 651.333 1033.9 627 1043.5 615M654 730.5C621.6 706.1 599.167 674.667 592 662C588.5 646.333 579 615 569 615"
        stroke="#EE3B11"
        stroke-width="8"
        stroke-linecap="round"
      />
      <path d="M1020 787.5V668.5M594.5 787.5V668.5" stroke="#EE3B11" stroke-width="5" stroke-linecap="square" />
      <path
        d="M1015.5 466C983.5 468.333 915.3 473.7 898.5 476.5C881.7 479.3 853.167 480.667 841 481M599 466C631 468.333 699.2 473.7 716 476.5C732.8 479.3 761.333 480.667 773.5 481"
        stroke="#EE3B11"
        stroke-width="5"
        stroke-linecap="square"
      />
      <path d="M882 378.5V430M738.5 378.5V430" stroke="#EE3B11" stroke-width="6" stroke-linecap="square" />
      <path
        d="M1002 998C995.833 1010.67 980.4 1038.8 968 1050M612.5 998C618.667 1010.67 634.1 1038.8 646.5 1050"
        stroke="#EE3B11"
        stroke-width="6"
        stroke-linecap="square"
      />
      <path
        d="M914.5 1156.5C900 1172 874.5 1199.17 853 1214C847.2 1218 831.333 1225.17 826.5 1227.5H787.5L760 1214C746.5 1204.5 716.5 1179.7 704.5 1156.5"
        stroke="#EE3B11"
        stroke-width="6"
        stroke-linecap="square"
      />
      <path d="M807 1393.5V1228" stroke="#EE3B11" stroke-width="6" stroke-linecap="square" />
      <circle
        @click="eventClickOnAreaModal(areas.temporomandibularD)"
        @mouseover="activeArea = areas.temporomandibularD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.temporomandibularD.selected ? activeColor : inactiveColor"
        :class="{ active: data.temporomandibularD.selected, hovered: activeArea == areas.temporomandibularD }"
        class="ax-selectable"
        cx="695"
        cy="236"
        r="44"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.temporomandibularE)"
        @mouseover="activeArea = areas.temporomandibularE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.temporomandibularE.selected ? activeColor : inactiveColor"
        :class="{ active: data.temporomandibularE.selected, hovered: activeArea == areas.temporomandibularE }"
        class="ax-selectable"
        cx="929"
        cy="236"
        r="44"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.ombroE)"
        @mouseover="activeArea = areas.ombroE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.ombroE.selected ? activeColor : inactiveColor"
        :class="{ active: data.ombroE.selected, hovered: activeArea == areas.ombroE }"
        class="ax-selectable"
        cx="1076"
        cy="568"
        r="54"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.cotoveloE)"
        @mouseover="activeArea = areas.cotoveloE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.cotoveloE.selected ? activeColor : inactiveColor"
        :class="{ active: data.cotoveloE.selected, hovered: activeArea == areas.cotoveloE }"
        class="ax-selectable"
        cx="1108"
        cy="885"
        r="54"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.cotoveloD)"
        @mouseover="activeArea = areas.cotoveloD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.cotoveloD.selected ? activeColor : inactiveColor"
        :class="{ active: data.cotoveloD.selected, hovered: activeArea == areas.cotoveloD }"
        class="ax-selectable"
        cx="509"
        cy="885"
        r="54"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.punhoD)"
        @mouseover="activeArea = areas.punhoD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.punhoD.selected ? activeColor : inactiveColor"
        :class="{ active: data.punhoD.selected, hovered: activeArea == areas.punhoD }"
        class="ax-selectable"
        cx="201"
        cy="1240"
        r="54"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.punhoE)"
        @mouseover="activeArea = areas.punhoE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.punhoE.selected ? activeColor : inactiveColor"
        :class="{ active: data.punhoE.selected, hovered: activeArea == areas.punhoE }"
        class="ax-selectable"
        cx="1385"
        cy="1240"
        r="54"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.meta1E)"
        @mouseover="activeArea = areas.meta1E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.meta1E.selected ? activeColor : inactiveColor"
        :class="{ active: data.meta1E.selected, hovered: activeArea == areas.meta1E }"
        class="ax-selectable"
        cx="1179"
        cy="1375"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.meta1D)"
        @mouseover="activeArea = areas.meta1D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.meta1D.selected ? activeColor : inactiveColor"
        :class="{ active: data.meta1D.selected, hovered: activeArea == areas.meta1D }"
        class="ax-selectable"
        cx="400"
        cy="1375"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximalMao1E)"
        @mouseover="activeArea = areas.proximalMao1E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximalMao1E.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximalMao1E.selected, hovered: activeArea == areas.proximalMao1E }"
        class="ax-selectable"
        cx="1119"
        cy="1449"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximalMao1D)"
        @mouseover="activeArea = areas.proximalMao1D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximalMao1D.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximalMao1D.selected, hovered: activeArea == areas.proximalMao1D }"
        class="ax-selectable"
        cx="449"
        cy="1449"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.meta2E)"
        @mouseover="activeArea = areas.meta2E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.meta2E.selected ? activeColor : inactiveColor"
        :class="{ active: data.meta2E.selected, hovered: activeArea == areas.meta2E }"
        class="ax-selectable"
        cx="1272"
        cy="1519"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.meta2D)"
        @mouseover="activeArea = areas.meta2D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.meta2D.selected ? activeColor : inactiveColor"
        :class="{ active: data.meta2D.selected, hovered: activeArea == areas.meta2D }"
        class="ax-selectable"
        cx="316"
        cy="1519"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.meta3E)"
        @mouseover="activeArea = areas.meta3E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.meta3E.selected ? activeColor : inactiveColor"
        :class="{ active: data.meta3E.selected, hovered: activeArea == areas.meta3E }"
        class="ax-selectable"
        cx="1350"
        cy="1519"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.meta3D)"
        @mouseover="activeArea = areas.meta3D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.meta3D.selected ? activeColor : inactiveColor"
        :class="{ active: data.meta3D.selected, hovered: activeArea == areas.meta3D }"
        class="ax-selectable"
        cx="226"
        cy="1519"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.meta4E)"
        @mouseover="activeArea = areas.meta4E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.meta4E.selected ? activeColor : inactiveColor"
        :class="{ active: data.meta4E.selected, hovered: activeArea == areas.meta4E }"
        class="ax-selectable"
        cx="1420"
        cy="1497"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.meta4D)"
        @mouseover="activeArea = areas.meta4D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.meta4D.selected ? activeColor : inactiveColor"
        :class="{ active: data.meta4D.selected, hovered: activeArea == areas.meta4D }"
        class="ax-selectable"
        cx="156"
        cy="1497"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.meta5E)"
        @mouseover="activeArea = areas.meta5E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.meta5E.selected ? activeColor : inactiveColor"
        :class="{ active: data.meta5E.selected, hovered: activeArea == areas.meta5E }"
        class="ax-selectable"
        cx="1498"
        cy="1462"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.meta5D)"
        @mouseover="activeArea = areas.meta5D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.meta5D.selected ? activeColor : inactiveColor"
        :class="{ active: data.meta5D.selected, hovered: activeArea == areas.meta5D }"
        class="ax-selectable"
        cx="78"
        cy="1462"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximalMao5E)"
        @mouseover="activeArea = areas.proximalMao5E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximalMao5E.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximalMao5E.selected, hovered: activeArea == areas.proximalMao5E }"
        class="ax-selectable"
        cx="1526"
        cy="1546"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximalMao5D)"
        @mouseover="activeArea = areas.proximalMao5D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximalMao5D.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximalMao5D.selected, hovered: activeArea == areas.proximalMao5D }"
        class="ax-selectable"
        cx="59"
        cy="1546"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.distalMao5E)"
        @mouseover="activeArea = areas.distalMao5E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.distalMao5E.selected ? activeColor : inactiveColor"
        :class="{ active: data.distalMao5E.selected, hovered: activeArea == areas.distalMao5E }"
        class="ax-selectable"
        cx="1542"
        cy="1630"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.distalMao5D)"
        @mouseover="activeArea = areas.distalMao5D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.distalMao5D.selected ? activeColor : inactiveColor"
        :class="{ active: data.distalMao5D.selected, hovered: activeArea == areas.distalMao5D }"
        class="ax-selectable"
        cx="35"
        cy="1630"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.distalMao4E)"
        @mouseover="activeArea = areas.distalMao4E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.distalMao4E.selected ? activeColor : inactiveColor"
        :class="{ active: data.distalMao4E.selected, hovered: activeArea == areas.distalMao4E }"
        class="ax-selectable"
        cx="1445"
        cy="1700"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.distalMao4D)"
        @mouseover="activeArea = areas.distalMao4D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.distalMao4D.selected ? activeColor : inactiveColor"
        :class="{ active: data.distalMao4D.selected, hovered: activeArea == areas.distalMao4D }"
        class="ax-selectable"
        cx="129"
        cy="1700"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximalMao4E)"
        @mouseover="activeArea = areas.proximalMao4E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximalMao4E.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximalMao4E.selected, hovered: activeArea == areas.proximalMao4E }"
        class="ax-selectable"
        cx="1436"
        cy="1616"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximalMao4D)"
        @mouseover="activeArea = areas.proximalMao4D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximalMao4D.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximalMao4D.selected, hovered: activeArea == areas.proximalMao4D }"
        class="ax-selectable"
        cx="141"
        cy="1616"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximalMao3E)"
        @mouseover="activeArea = areas.proximalMao3E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximalMao3E.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximalMao3E.selected, hovered: activeArea == areas.proximalMao3E }"
        class="ax-selectable"
        cx="1350"
        cy="1638"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximalMao3D)"
        @mouseover="activeArea = areas.proximalMao3D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximalMao3D.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximalMao3D.selected, hovered: activeArea == areas.proximalMao3D }"
        class="ax-selectable"
        cx="224"
        cy="1638"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.distalMao3E)"
        @mouseover="activeArea = areas.distalMao3E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.distalMao3E.selected ? activeColor : inactiveColor"
        :class="{ active: data.distalMao3E.selected, hovered: activeArea == areas.distalMao3E }"
        class="ax-selectable"
        cx="1350"
        cy="1735"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.distalMao3D)"
        @mouseover="activeArea = areas.distalMao3D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.distalMao3D.selected ? activeColor : inactiveColor"
        :class="{ active: data.distalMao3D.selected, hovered: activeArea == areas.distalMao3D }"
        class="ax-selectable"
        cx="226"
        cy="1735"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.distalMao2E)"
        @mouseover="activeArea = areas.distalMao2E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.distalMao2E.selected ? activeColor : inactiveColor"
        :class="{ active: data.distalMao2E.selected, hovered: activeArea == areas.distalMao2E }"
        class="ax-selectable"
        cx="1237"
        cy="1700"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.distalMao2D)"
        @mouseover="activeArea = areas.distalMao2D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.distalMao2D.selected ? activeColor : inactiveColor"
        :class="{ active: data.distalMao2D.selected, hovered: activeArea == areas.distalMao2D }"
        class="ax-selectable"
        cx="338"
        cy="1700"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximalMao2E)"
        @mouseover="activeArea = areas.proximalMao2E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximalMao2E.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximalMao2E.selected, hovered: activeArea == areas.proximalMao2E }"
        class="ax-selectable"
        cx="1244"
        cy="1616"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximalMao2D)"
        @mouseover="activeArea = areas.proximalMao2D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximalMao2D.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximalMao2D.selected, hovered: activeArea == areas.proximalMao2D }"
        class="ax-selectable"
        cx="330"
        cy="1616"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.quadrilE)"
        @mouseover="activeArea = areas.quadrilE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.quadrilE.selected ? activeColor : inactiveColor"
        :class="{ active: data.quadrilE.selected, hovered: activeArea == areas.quadrilE }"
        class="ax-selectable"
        cx="962"
        cy="1161"
        r="54"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.joelhoE)"
        @mouseover="activeArea = areas.joelhoE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.joelhoE.selected ? activeColor : inactiveColor"
        :class="{ active: data.joelhoE.selected, hovered: activeArea == areas.joelhoE }"
        class="ax-selectable"
        cx="930"
        cy="1717"
        r="54"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.joelhoD)"
        @mouseover="activeArea = areas.joelhoD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.joelhoD.selected ? activeColor : inactiveColor"
        :class="{ active: data.joelhoD.selected, hovered: activeArea == areas.joelhoD }"
        class="ax-selectable"
        cx="686"
        cy="1717"
        r="54"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.tornozeloD)"
        @mouseover="activeArea = areas.tornozeloD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.tornozeloD.selected ? activeColor : inactiveColor"
        :class="{ active: data.tornozeloD.selected, hovered: activeArea == areas.tornozeloD }"
        class="ax-selectable"
        cx="588"
        cy="2002"
        r="54"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.tornozeloE)"
        @mouseover="activeArea = areas.tornozeloE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.tornozeloE.selected ? activeColor : inactiveColor"
        :class="{ active: data.tornozeloE.selected, hovered: activeArea == areas.tornozeloE }"
        class="ax-selectable"
        cx="1032"
        cy="1990"
        r="54"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.tarsoE)"
        @mouseover="activeArea = areas.tarsoE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.tarsoE.selected ? activeColor : inactiveColor"
        :class="{ active: data.tarsoE.selected, hovered: activeArea == areas.tarsoE }"
        class="ax-selectable"
        cx="1050"
        cy="2243"
        r="54"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.tarsoD)"
        @mouseover="activeArea = areas.tarsoD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.tarsoD.selected ? activeColor : inactiveColor"
        :class="{ active: data.tarsoD.selected, hovered: activeArea == areas.tarsoD }"
        class="ax-selectable"
        cx="566"
        cy="2259"
        r="54"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.metatar1D)"
        @mouseover="activeArea = areas.metatar1D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.metatar1D.selected ? activeColor : inactiveColor"
        :class="{ active: data.metatar1D.selected, hovered: activeArea == areas.metatar1D }"
        class="ax-selectable"
        cx="705"
        cy="2700"
        r="34"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.metatar1E)"
        @mouseover="activeArea = areas.metatar1E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.metatar1E.selected ? activeColor : inactiveColor"
        :class="{ active: data.metatar1E.selected, hovered: activeArea == areas.metatar1E }"
        class="ax-selectable"
        cx="919"
        cy="2692"
        r="34"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.metatar2D)"
        @mouseover="activeArea = areas.metatar2D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.metatar2D.selected ? activeColor : inactiveColor"
        :class="{ active: data.metatar2D.selected, hovered: activeArea == areas.metatar2D }"
        class="ax-selectable"
        cx="614"
        cy="2660"
        r="34"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.metatar2E)"
        @mouseover="activeArea = areas.metatar2E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.metatar2E.selected ? activeColor : inactiveColor"
        :class="{ active: data.metatar2E.selected, hovered: activeArea == areas.metatar2E }"
        class="ax-selectable"
        cx="1020"
        cy="2660"
        r="34"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.metatar3D)"
        @mouseover="activeArea = areas.metatar3D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.metatar3D.selected ? activeColor : inactiveColor"
        :class="{ active: data.metatar3D.selected, hovered: activeArea == areas.metatar3D }"
        class="ax-selectable"
        cx="534"
        cy="2637"
        r="34"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.metatar3E)"
        @mouseover="activeArea = areas.metatar3E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.metatar3E.selected ? activeColor : inactiveColor"
        :class="{ active: data.metatar3E.selected, hovered: activeArea == areas.metatar3E }"
        class="ax-selectable"
        cx="1100"
        cy="2637"
        r="34"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.metatar4D)"
        @mouseover="activeArea = areas.metatar4D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.metatar4D.selected ? activeColor : inactiveColor"
        :class="{ active: data.metatar4D.selected, hovered: activeArea == areas.metatar4D }"
        class="ax-selectable"
        cx="454"
        cy="2620"
        r="34"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.metatar4E)"
        @mouseover="activeArea = areas.metatar4E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.metatar4E.selected ? activeColor : inactiveColor"
        :class="{ active: data.metatar4E.selected, hovered: activeArea == areas.metatar4E }"
        class="ax-selectable"
        cx="1177"
        cy="2614"
        r="34"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.metatar5D)"
        @mouseover="activeArea = areas.metatar5D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.metatar5D.selected ? activeColor : inactiveColor"
        :class="{ active: data.metatar5D.selected, hovered: activeArea == areas.metatar5D }"
        class="ax-selectable"
        cx="367"
        cy="2627"
        r="34"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.metatar5E)"
        @mouseover="activeArea = areas.metatar5E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.metatar5E.selected ? activeColor : inactiveColor"
        :class="{ active: data.metatar5E.selected, hovered: activeArea == areas.metatar5E }"
        class="ax-selectable"
        cx="1262"
        cy="2622"
        r="34"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximal5D)"
        @mouseover="activeArea = areas.proximal5D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximal5D.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximal5D.selected, hovered: activeArea == areas.proximal5D }"
        class="ax-selectable"
        cx="372"
        cy="2717"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximal5E)"
        @mouseover="activeArea = areas.proximal5E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximal5E.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximal5E.selected, hovered: activeArea == areas.proximal5E }"
        class="ax-selectable"
        cx="1250"
        cy="2703"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximal4D)"
        @mouseover="activeArea = areas.proximal4D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximal4D.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximal4D.selected, hovered: activeArea == areas.proximal4D }"
        class="ax-selectable"
        cx="443"
        cy="2735"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximal4E)"
        @mouseover="activeArea = areas.proximal4E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximal4E.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximal4E.selected, hovered: activeArea == areas.proximal4E }"
        class="ax-selectable"
        cx="1181"
        cy="2717"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximal3D)"
        @mouseover="activeArea = areas.proximal3D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximal3D.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximal3D.selected, hovered: activeArea == areas.proximal3D }"
        class="ax-selectable"
        cx="514"
        cy="2747"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximal3E)"
        @mouseover="activeArea = areas.proximal3E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximal3E.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximal3E.selected, hovered: activeArea == areas.proximal3E }"
        class="ax-selectable"
        cx="1109"
        cy="2736"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximal2D)"
        @mouseover="activeArea = areas.proximal2D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximal2D.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximal2D.selected, hovered: activeArea == areas.proximal2D }"
        class="ax-selectable"
        cx="584"
        cy="2762"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximal2E)"
        @mouseover="activeArea = areas.proximal2E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximal2E.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximal2E.selected, hovered: activeArea == areas.proximal2E }"
        class="ax-selectable"
        cx="1040"
        cy="2760"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximal1D)"
        @mouseover="activeArea = areas.proximal1D"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximal1D.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximal1D.selected, hovered: activeArea == areas.proximal1D }"
        class="ax-selectable"
        cx="677"
        cy="2797"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.proximal1E)"
        @mouseover="activeArea = areas.proximal1E"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.proximal1E.selected ? activeColor : inactiveColor"
        :class="{ active: data.proximal1E.selected, hovered: activeArea == areas.proximal1E }"
        class="ax-selectable"
        cx="940"
        cy="2797"
        r="29"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.quadrilD)"
        @mouseover="activeArea = areas.quadrilD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.quadrilD.selected ? activeColor : inactiveColor"
        :class="{ active: data.quadrilD.selected, hovered: activeArea == areas.quadrilD }"
        class="ax-selectable"
        cx="654"
        cy="1161"
        r="54"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.ombroD)"
        @mouseover="activeArea = areas.ombroD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.ombroD.selected ? activeColor : inactiveColor"
        :class="{ active: data.ombroD.selected, hovered: activeArea == areas.ombroD }"
        class="ax-selectable"
        cx="539"
        cy="568"
        r="54"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.acromioclavicularD)"
        @mouseover="activeArea = areas.acromioclavicularD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.acromioclavicularD.selected ? activeColor : inactiveColor"
        :class="{ active: data.acromioclavicularD.selected, hovered: activeArea == areas.acromioclavicularD }"
        class="ax-selectable"
        cx="595"
        cy="463"
        r="39"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.acromioclavicularE)"
        @mouseover="activeArea = areas.acromioclavicularE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.acromioclavicularE.selected ? activeColor : inactiveColor"
        :class="{ active: data.acromioclavicularE.selected, hovered: activeArea == areas.acromioclavicularE }"
        class="ax-selectable"
        cx="1044"
        cy="463"
        r="39"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.esternoclavicularE)"
        @mouseover="activeArea = areas.esternoclavicularE"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.esternoclavicularE.selected ? activeColor : inactiveColor"
        :class="{ active: data.esternoclavicularE.selected, hovered: activeArea == areas.esternoclavicularE }"
        class="ax-selectable"
        cx="889"
        cy="500"
        r="44"
        stroke="#0081F9"
        stroke-width="12"
      />
      <circle
        @click="eventClickOnAreaModal(areas.esternoclavicularD)"
        @mouseover="activeArea = areas.esternoclavicularD"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.esternoclavicularD.selected ? activeColor : inactiveColor"
        :class="{ active: data.esternoclavicularD.selected, hovered: activeArea == areas.esternoclavicularD }"
        class="ax-selectable"
        cx="719"
        cy="500"
        r="44"
        stroke="#0081F9"
        stroke-width="12"
      />
    </svg>
    <v-dialog v-model="dialog" persistent v-if="currentArea" max-width="600px">
      <v-card>
        <v-card-title class="justify-center">{{ currentArea.label }}</v-card-title>
        <div class="ml-10">
          <v-checkbox v-if="!currentArea.hideInch" dense v-model="currentArea.inchSelected" label="Inchada" />
          <v-checkbox dense v-model="currentArea.dorSelected" label="Dolorosa" />
        </div>
        <v-card-actions :class="{ 'd-flex flex-column align-center': $vuetify.breakpoint.smAndDown }">
          <v-btn @click="cancelAreaSelection(false)" text :class="{ 'ml-auto': !$vuetify.breakpoint.smAndDown }"
            >Cancelar</v-btn
          >
          <v-btn @click="cancelAreaSelection(true)" text class="red--text">Cancelar seleção da área</v-btn>
          <v-btn @click="confirmAreaSelection" class="primary" :disabled="isButtonDisabled">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-tooltip :value="!!activeArea" :position-x="tooltipPositionX" :position-y="tooltipPositionY" top>
      {{ tooltiplabel }}
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    height: String,
    width: String,
    value: Object,
  },
  computed: {
    isButtonDisabled() {
      return !this.currentArea.dorSelected && !this.currentArea.inchSelected
    },
    tooltiplabel() {
      return this.activeArea?.label || ''
    },
  },
  methods: {
    buildEmptyDataObject() {
      return Object.values(this.areas).reduce(
        (acc, option) => ({
          ...acc,
          [option.key]: { selected: false, dorSelected: false, inchSelected: false, label: option.label },
        }),
        {},
      )
    },
    setPosition(e) {
      this.tooltipPositionX = e.clientX
      this.tooltipPositionY = e.clientY
    },
    eventClickOnAreaModal(clickedArea) {
      if (clickedArea.hideInch) {
        this.data[clickedArea.key].selected = !this.data[clickedArea.key].selected
        this.data[clickedArea.key].dorSelected = !this.data[clickedArea.key].dorSelected
        this.$emit('input', this.data)
      } else {
        this.currentArea = { ...this.data[clickedArea.key], ...clickedArea }
        this.dialog = true
      }
    },
    cancelAreaSelection(shouldEraseData = false) {
      if (shouldEraseData) {
        this.data[this.currentArea.key].selected = false
        this.data[this.currentArea.key].inchSelected = false
        this.data[this.currentArea.key].dorSelected = false
      }
      this.currentArea = null
      this.dialog = false
      this.$emit('input', this.data)
    },
    confirmAreaSelection() {
      this.data[this.currentArea.key].selected = true
      this.data[this.currentArea.key].inchSelected = this.currentArea.inchSelected
      this.data[this.currentArea.key].dorSelected = this.currentArea.dorSelected
      this.currentArea = null
      this.dialog = false
      this.$emit('input', this.data)
    },
  },
  mounted() {
    this.data = { ...this.buildEmptyDataObject(), ...this.value }
    this.isMounted = true
  },
  data() {
    return {
      isMounted: false,
      activeColor: '#ff0000',
      inactiveColor: '#fff',
      data: null,
      tooltipPositionX: null,
      tooltipPositionY: null,
      dialog: false,
      currentArea: null,
      activeArea: null,
      areas: {
        maiorD: {
          key: 'maiorD',
          label: 'Trocânter maior D',
        },
        maiorE: {
          key: 'maiorE',
          label: 'Trocânter maior E',
        },
        meta1D: {
          key: 'meta1D',
          label: '1ª Metacarpofalangeana D',
        },
        meta1E: {
          key: 'meta1E',
          label: '1ª Metacarpofalangeana E',
        },
        meta2D: {
          key: 'meta2D',
          label: '2ª Metacarpofalangeana D',
        },
        meta2E: {
          key: 'meta2E',
          label: '2ª Metacarpofalangeana E',
        },
        meta3D: {
          key: 'meta3D',
          label: '3ª Metacarpofalangeana D',
        },
        meta3E: {
          key: 'meta3E',
          label: '3ª Metacarpofalangeana E',
        },
        meta4D: {
          key: 'meta4D',
          label: '4ª Metacarpofalangeana D',
        },
        meta4E: {
          key: 'meta4E',
          label: '4ª Metacarpofalangeana E',
        },
        meta5D: {
          key: 'meta5D',
          label: '5ª Metacarpofalangeana D',
        },
        meta5E: {
          key: 'meta5E',
          label: '5ª Metacarpofalangeana E',
        },
        ombroD: {
          key: 'ombroD',
          label: 'Ombro D',
        },
        ombroE: {
          key: 'ombroE',
          label: 'Ombro E',
        },
        punhoD: {
          key: 'punhoD',
          label: 'Punho D',
        },
        punhoE: {
          key: 'punhoE',
          label: 'Punho E',
        },
        tarsoD: {
          key: 'tarsoD',
          label: 'Tarso D',
        },
        tarsoE: {
          key: 'tarsoE',
          label: 'Tarso E',
        },
        tibiaD: {
          key: 'tibiaD',
          label: 'Tíbia D',
        },
        tibiaE: {
          key: 'tibiaE',
          label: 'Tíbia E',
        },
        cristaD: {
          key: 'cristaD',
          label: 'Crista ilíaca D',
        },
        cristaE: {
          key: 'cristaE',
          label: 'Crista ilíaca E',
        },
        joelhoD: {
          key: 'joelhoD',
          label: 'Joelho D',
        },
        joelhoE: {
          key: 'joelhoE',
          label: 'Joelho E',
        },
        medialD: {
          key: 'medialD',
          label: 'Epicôndilo medial D',
        },
        medialE: {
          key: 'medialE',
          label: 'Epicôndilo medial E',
        },
        aquilesD: {
          key: 'aquilesD',
          label: 'Tendão de Aquiles D',
        },
        aquilesE: {
          key: 'aquilesE',
          label: 'Tendão de Aquiles E',
        },
        lateralD: {
          key: 'lateralD',
          label: 'Epicôndilo lateral D',
        },
        lateralE: {
          key: 'lateralE',
          label: 'Epicôndilo lateral E',
        },
        patelarD: {
          key: 'patelarD',
          label: 'Ligamento patelar D',
        },
        patelarE: {
          key: 'patelarE',
          label: 'Ligamento patelar E',
        },
        plantarD: {
          key: 'plantarD',
          label: 'Fáscia plantar  D',
        },
        plantarE: {
          key: 'plantarE',
          label: 'Fáscia plantar  D',
        },
        quadrilD: {
          key: 'quadrilD',
          label: 'Quadril D',
          hideInch: true,
        },
        quadrilE: {
          key: 'quadrilE',
          label: 'Quadril E',
          hideInch: true,
        },
        cotoveloD: {
          key: 'cotoveloD',
          label: 'Cotovelo D',
        },
        cotoveloE: {
          key: 'cotoveloE',
          label: 'Cotovelo E',
        },
        metatar1D: {
          key: 'metatar1D',
          label: '1ª Metatarsofalangeana D',
        },
        metatar1E: {
          key: 'metatar1E',
          label: '1ª Metatarsofalangeana E',
        },
        metatar2D: {
          key: 'metatar2D',
          label: '2ª Metatarsofalangeana D',
        },
        metatar2E: {
          key: 'metatar2E',
          label: '2ª Metatarsofalangeana E',
        },
        metatar3D: {
          key: 'metatar3D',
          label: '3ª Metatarsofalangeana D',
        },
        metatar3E: {
          key: 'metatar3E',
          label: '3ª Metatarsofalangeana E',
        },
        metatar4D: {
          key: 'metatar4D',
          label: '4ª Metatarsofalangeana D',
        },
        metatar4E: {
          key: 'metatar4E',
          label: '4ª Metatarsofalangeana E',
        },
        metatar5D: {
          key: 'metatar5D',
          label: '5ª Metatarsofalangeana D',
        },
        metatar5E: {
          key: 'metatar5E',
          label: '5ª Metatarsofalangeana E',
        },
        dedo1podoD: {
          key: 'dedo1podoD',
          label: 'Dedo - 1º pododáctilo D',
        },
        dedo1podoE: {
          key: 'dedo1podoE',
          label: 'Dedo - 1º pododáctilo E',
        },
        dedo2podoD: {
          key: 'dedo2podoD',
          label: 'Dedo - 2º pododáctilo D',
        },
        dedo2podoE: {
          key: 'dedo2podoE',
          label: 'Dedo - 2º pododáctilo E',
        },
        dedo3podoD: {
          key: 'dedo3podoD',
          label: 'Dedo - 3º pododáctilo D',
        },
        dedo3podoE: {
          key: 'dedo3podoE',
          label: 'Dedo - 3º pododáctilo E',
        },
        dedo4podoD: {
          key: 'dedo4podoD',
          label: 'Dedo - 4º pododáctilo D',
        },
        dedo4podoE: {
          key: 'dedo4podoE',
          label: 'Dedo - 4º pododáctilo E',
        },
        dedo5podoD: {
          key: 'dedo5podoD',
          label: 'Dedo - 5º pododáctilo D',
        },
        dedo5podoE: {
          key: 'dedo5podoE',
          label: 'Dedo - 5º pododáctilo E',
        },
        espinhoso5: {
          key: 'espinhoso5',
          label: '5º processo espinhoso lombar',
        },
        proximal1D: {
          key: 'proximal1D',
          label: '1ª Interfalangeana proximal pé D',
        },
        proximal1E: {
          key: 'proximal1E',
          label: '1ª Interfalangeana proximal pé E',
        },
        proximal2D: {
          key: 'proximal2D',
          label: '2ª Interfalangeana proximal pé D',
        },
        proximal2E: {
          key: 'proximal2E',
          label: '2ª Interfalangeana proximal pé E',
        },
        proximal3D: {
          key: 'proximal3D',
          label: '3ª Interfalangeana proximal pé D',
        },
        proximal3E: {
          key: 'proximal3E',
          label: '3ª Interfalangeana proximal pé E',
        },
        proximal4D: {
          key: 'proximal4D',
          label: '4ª Interfalangeana proximal pé D',
        },
        proximal4E: {
          key: 'proximal4E',
          label: '4ª Interfalangeana proximal pé E',
        },
        proximal5D: {
          key: 'proximal5D',
          label: '5ª Interfalangeana proximal pé D',
        },
        proximal5E: {
          key: 'proximal5E',
          label: '5ª Interfalangeana proximal pé E',
        },
        tornozeloD: {
          key: 'tornozeloD',
          label: 'Tornozelo D',
        },
        tornozeloE: {
          key: 'tornozeloE',
          label: 'Tornozelo E',
        },
        unha1podoD: {
          key: 'unha1podoD',
          label: 'Unha - 1º pododáctilo D',
        },
        unha1podoE: {
          key: 'unha1podoE',
          label: 'Unha - 1º pododáctilo E',
        },
        unha2podoD: {
          key: 'unha2podoD',
          label: 'Unha - 2º pododáctilo D',
        },
        unha2podoE: {
          key: 'unha2podoE',
          label: 'Unha - 2º pododáctilo E',
        },
        unha3podoD: {
          key: 'unha3podoD',
          label: 'Unha - 3º pododáctilo D',
        },
        unha3podoE: {
          key: 'unha3podoE',
          label: 'Unha - 3º pododáctilo E',
        },
        unha4podoD: {
          key: 'unha4podoD',
          label: 'Unha - 4º pododáctilo D',
        },
        unha4podoE: {
          key: 'unha4podoE',
          label: 'Unha - 4º pododáctilo E',
        },
        unha5podoD: {
          key: 'unha5podoD',
          label: 'Unha - 5º pododáctilo D',
        },
        unha5podoE: {
          key: 'unha5podoE',
          label: 'Unha - 5º pododáctilo E',
        },
        dedo1quiroD: {
          key: 'dedo1quiroD',
          label: 'Dedo - 1º quirodáctilo D',
        },
        dedo1quiroE: {
          key: 'dedo1quiroE',
          label: 'Dedo - 1º quirodáctilo E',
        },
        dedo2quiroD: {
          key: 'dedo2quiroD',
          label: 'Dedo - 2º quirodáctilo D',
        },
        dedo2quiroE: {
          key: 'dedo2quiroE',
          label: 'Dedo - 2º quirodáctilo E',
        },
        dedo3quiroD: {
          key: 'dedo3quiroD',
          label: 'Dedo - 3º quirodáctilo D',
        },
        dedo3quiroE: {
          key: 'dedo3quiroE',
          label: 'Dedo - 3º quirodáctilo E',
        },
        dedo4quiroD: {
          key: 'dedo4quiroD',
          label: 'Dedo - 4º quirodáctilo D',
        },
        dedo4quiroE: {
          key: 'dedo4quiroE',
          label: 'Dedo - 4º quirodáctilo E',
        },
        dedo5quiroD: {
          key: 'dedo5quiroD',
          label: 'Dedo - 5º quirodáctilo D',
        },
        dedo5quiroE: {
          key: 'dedo5quiroE',
          label: 'Dedo - 5º quirodáctilo E',
        },
        distalMao2D: {
          key: 'distalMao2D',
          label: '2ª Interfalangeana distal mão D',
        },
        distalMao2E: {
          key: 'distalMao2E',
          label: '2ª Interfalangeana distal mão E',
        },
        distalMao3D: {
          key: 'distalMao3D',
          label: '3ª Interfalangeana distal mão D',
        },
        distalMao3E: {
          key: 'distalMao3E',
          label: '3ª Interfalangeana distal mão E',
        },
        distalMao4D: {
          key: 'distalMao4D',
          label: '4ª Interfalangeana distal mão D',
        },
        distalMao4E: {
          key: 'distalMao4E',
          label: '4ª Interfalangeana distal mão E',
        },
        distalMao5D: {
          key: 'distalMao5D',
          label: '5ª Interfalangeana distal mão D',
        },
        distalMao5E: {
          key: 'distalMao5E',
          label: '5ª Interfalangeana distal mão E',
        },
        isquiaticaD: {
          key: 'isquiaticaD',
          label: 'Tuberosidade isquiática D',
        },
        isquiaticaE: {
          key: 'isquiaticaE',
          label: 'Tuberosidade isquiática E',
        },
        quadricepsD: {
          key: 'quadricepsD',
          label: 'Tendão do quadríceps D',
        },
        quadricepsE: {
          key: 'quadricepsE',
          label: 'Tendão do quadríceps E',
        },
        unha1quiroD: {
          key: 'unha1quiroD',
          label: 'Unha - 1º quirodáctilo D',
        },
        unha1quiroE: {
          key: 'unha1quiroE',
          label: 'Unha - 1º quirodáctilo E',
        },
        unha2quiroD: {
          key: 'unha2quiroD',
          label: 'Unha - 2º quirodáctilo D',
        },
        unha2quiroE: {
          key: 'unha2quiroE',
          label: 'Unha - 2º quirodáctilo E',
        },
        unha3quiroD: {
          key: 'unha3quiroD',
          label: 'Unha - 3º quirodáctilo D',
        },
        unha3quiroE: {
          key: 'unha3quiroE',
          label: 'Unha - 3º quirodáctilo E',
        },
        unha4quiroD: {
          key: 'unha4quiroD',
          label: 'Unha - 4º quirodáctilo D',
        },
        unha4quiroE: {
          key: 'unha4quiroE',
          label: 'Unha - 4º quirodáctilo E',
        },
        unha5quiroD: {
          key: 'unha5quiroD',
          label: 'Unha - 5º quirodáctilo D',
        },
        unha5quiroE: {
          key: 'unha5quiroE',
          label: 'Unha - 5º quirodáctilo E',
        },
        medialFemurD: {
          key: 'medialFemurD',
          label: 'Côndilo medial do fêmur D',
        },
        medialFemurE: {
          key: 'medialFemurE',
          label: 'Côndilo medial do fêmur E',
        },
        tendaoSupraD: {
          key: 'tendaoSupraD',
          label: 'Tendão supraespinhoso D',
        },
        tendaoSupraE: {
          key: 'tendaoSupraE',
          label: 'Tendão supraespinhoso E',
        },
        lateralFemurD: {
          key: 'lateralFemurD',
          label: 'Côndilo lateral do fêmur D',
        },
        lateralFemurE: {
          key: 'lateralFemurE',
          label: 'Côndilo lateral do fêmur E',
        },
        proximalMao1D: {
          key: 'proximalMao1D',
          label: '1ª Interfalangeana proximal mão D',
        },
        proximalMao1E: {
          key: 'proximalMao1E',
          label: '1ª Interfalangeana proximal mão E',
        },
        proximalMao2D: {
          key: 'proximalMao2D',
          label: '2ª Interfalangeana proximal mão D',
        },
        proximalMao2E: {
          key: 'proximalMao2E',
          label: '2ª Interfalangeana proximal mão E',
        },
        proximalMao3D: {
          key: 'proximalMao3D',
          label: '3ª Interfalangeana proximal mão D',
        },
        proximalMao3E: {
          key: 'proximalMao3E',
          label: '3ª Interfalangeana proximal mão E',
        },
        proximalMao4D: {
          key: 'proximalMao4D',
          label: '4ª Interfalangeana proximal mão D',
        },
        proximalMao4E: {
          key: 'proximalMao4E',
          label: '4ª Interfalangeana proximal mão E',
        },
        proximalMao5D: {
          key: 'proximalMao5D',
          label: '5ª Interfalangeana proximal mão D',
        },
        proximalMao5E: {
          key: 'proximalMao5E',
          label: '5ª Interfalangeana proximal mão E',
        },
        costocondral1D: {
          key: 'costocondral1D',
          label: '1ª costocondral D',
        },
        costocondral1E: {
          key: 'costocondral1E',
          label: '1ª costocondral E',
        },
        costocondral7D: {
          key: 'costocondral7D',
          label: '7ª costocondral D',
        },
        costocondral7E: {
          key: 'costocondral7E',
          label: '7ª costocondral E',
        },
        anteroSuperiorD: {
          key: 'anteroSuperiorD',
          label: 'Espinha ilíaca ântero-superior D',
        },
        anteroSuperiorE: {
          key: 'anteroSuperiorE',
          label: 'Espinha ilíaca ântero-superior E',
        },
        posteroSuperiorD: {
          key: 'posteroSuperiorD',
          label: 'Espinha ilíaca póstero-superior D',
        },
        posteroSuperiorE: {
          key: 'posteroSuperiorE',
          label: 'Espinha ilíaca póstero-superior E',
        },
        acromioclavicularD: {
          key: 'acromioclavicularD',
          label: 'Acromioclavicular D',
        },
        acromioclavicularE: {
          key: 'acromioclavicularE',
          label: 'Acromioclavicular E',
        },
        esternoclavicularD: {
          key: 'esternoclavicularD',
          label: 'Esternoclavicular D',
        },
        esternoclavicularE: {
          key: 'esternoclavicularE',
          label: 'Esternoclavicular E',
        },
        temporomandibularD: {
          key: 'temporomandibularD',
          label: 'Temporomandibular D',
        },
        temporomandibularE: {
          key: 'temporomandibularE',
          label: 'Temporomandibular E',
        },
      },
    }
  },
}
</script>

<style scoped>
.areas {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.ax-selectable {
  cursor: pointer;
  transition: all 0.1s ease-in-out;
}
.ax-selectable.hovered:not(.active) {
  fill: #9c9c9c;
}
.ax-label {
  position: fixed;
  background: #aaa021;
  color: white;
  padding: 4px 14px;
  font-size: 0.8rem;
  border-radius: 8px;
  box-shadow: 0 0 3px 0 #3a3a3a42;
  user-select: none;
}
.ax-thumbnails {
  display: flex;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item {
  height: 106px;
  width: 106px;
  border-radius: 5px;
  background: #e8e8e870;
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item.active {
  border: 2px solid #aba022;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item:hover {
  border: 2px solid rgba(171, 160, 34, 0.6);
}
.ax-thumbnails .ax-thumbs .ax-thumb-item:first-of-type {
  margin-top: 0;
}
.ax-selected-areas {
  padding: 1rem 1.8rem;
  border-left: 1px solid #dee2e6;
  width: 250px;
}
.ax-selected-areas > p {
  font-weight: bold;
}
.ax-selected-areas > ul {
  list-style: none;
  padding: 0;
  margin: 1.4rem 0;
}
.ax-selected-areas > ul > li {
  display: flex;
  justify-content: space-between;
  margin: 0 0 0.8rem;
}
.ax-selected-areas > ul > li > span {
  width: 100%;
}
.ax-selected-areas > ul > li > i {
  color: #e0e0e0;
  cursor: pointer;
}
.items-questions {
  align-self: center;
  height: fit-content;
}

.icon-page {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-7%);
  transform: translateY(-50%);
}

.answer-areas {
  background: #f6f6f6;
  padding-top: 0.1rem;
  padding-bottom: 0.7rem;
  margin-top: 0.5rem !important;
}

.answer-areas-position {
  margin-left: 40px;
}

.answer-text-position {
  margin-left: 25px;
}

body {
  color: #636c72;
}

body nick-checkbox .form-group,
.page-router-container nick-checkbox .form-group {
  margin: 0 !important;
  float: left;
  height: auto;
}

.form-group {
  margin-bottom: 0rem;
}

.page-router-container .nick-radio-options .nick-radio-option {
  width: 33.3333%;
  margin: 0px;
}

.ax-selected-areas {
  width: 300px;
}

label {
  margin-bottom: 0px;
}

.modal-dialog {
  max-width: 650px;
}

#items-wrapper {
  width: 100%;
}

#items {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

.item {
  flex: none;
  width: 100%;
  height: 100%;
  scroll-snap-align: start;
  pointer-events: none;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
